import { render, staticRenderFns } from "./VFAsDetail.vue?vue&type=template&id=66577ae8"
import script from "./VFAsDetail.vue?vue&type=script&lang=js"
export * from "./VFAsDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports